var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99953 6.00014V8.6668M7.99953 11.3335H8.00619M6.85953 2.57347L1.21286 12.0001C1.09644 12.2018 1.03484 12.4303 1.03418 12.6631C1.03353 12.896 1.09385 13.1249 1.20914 13.3272C1.32443 13.5294 1.49068 13.698 1.69133 13.816C1.89199 13.9341 2.12006 13.9976 2.35286 14.0001H13.6462C13.879 13.9976 14.1071 13.9341 14.3077 13.816C14.5084 13.698 14.6746 13.5294 14.7899 13.3272C14.9052 13.1249 14.9655 12.896 14.9649 12.6631C14.9642 12.4303 14.9026 12.2018 14.7862 12.0001L9.13953 2.57347C9.02068 2.37754 8.85334 2.21555 8.65366 2.10313C8.45397 1.9907 8.22868 1.93164 7.99953 1.93164C7.77037 1.93164 7.54508 1.9907 7.3454 2.10313C7.14571 2.21555 6.97837 2.37754 6.85953 2.57347Z",
    stroke: "#A98200",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationYellow);
export default __webpack_public_path__ + "static/media/exclamation-yellow.891204294831efe7c4fb6e2a19c6dcfe.svg";
export { ForwardRef as ReactComponent };